import React from 'react'
import '.././styles/dashboard.css';

export default function Item({text, remove, complete}) {
    return (
        <>
        <div className="item">
            <div className="text">{text}</div>
            <div className="icons">
                <i className="fa fa-check-circle icon" onClick={complete}></i>
                <i className="fa fa-trash-o icon" onClick={remove}></i>
            </div>
        </div>
        </>
    )
}